// GraphQL error codes surfaced via `extensions: { code: ... }` on
// `GraphQL::ExecutionError`. Shared so the raise site (Rails) and the detect
// sites (Apollo error link, mutation catch helper) agree on the wire value.

export const READ_ONLY_ADMIN_WRITE_DENIED_CODE = 'READ_ONLY_ADMIN_WRITE_DENIED';
export const ESTIMATED_AUM_REQUIRED_CODE = 'ESTIMATED_AUM_REQUIRED';
export const PROFESSIONAL_RELATIONSHIP_ACCESS_DENIED_CODE = 'PROFESSIONAL_RELATIONSHIP_ACCESS_DENIED';
export const PROFESSIONAL_CONTACT_ACCESS_DENIED_CODE = 'PROFESSIONAL_CONTACT_ACCESS_DENIED';
